import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loadState, saveState } from './index';

// Define a type for the slice state
export interface MaterialState {
    materialGroup: number,
    id: number,
    name: string,
    description: string,
    hardness: number;
    hardnessScale: string;
    tensileStrength: number;
}

const placeholderState = {
    materialGroup: 0,
    id: 0,
    name: '',
    description: '',
    hardness: 0,
    hardnessScale: "HBS",
    tensileStrength: 0
}

// Define the initial state using that type
const initialState: MaterialState = loadState('material', placeholderState);

export const counterSlice = createSlice({
    name: 'material',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        set: (state, action: PayloadAction<MaterialState>) => {
            state.materialGroup = action.payload.materialGroup;
            state.hardness = action.payload.hardness;
            state.hardnessScale = action.payload.hardnessScale;
            state.tensileStrength = action.payload.tensileStrength;
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.description = action.payload.description;
            saveState('material', state);
        },
        reset: (state) => {
            Object.keys(placeholderState).forEach(key => {
                // @ts-ignore
                state[key] = placeholderState[key];
            })
            saveState('material', state);
        },
        setHardness: (state, action: PayloadAction<number>) => {
            state.hardness = action.payload;
            saveState('material', state);
        },
        setHardnessScale: (state, action: PayloadAction<string>) => {
            state.hardnessScale = action.payload;
            saveState('material', state);
        },
        setTensileStrength: (state, action: PayloadAction<number>) => {
            state.tensileStrength = action.payload;
            saveState('material', state);
        }
    },
})

export const { set, reset, setHardness, setHardnessScale, setTensileStrength } = counterSlice.actions;

export default counterSlice.reducer
